module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/webpolls/bravenet_webpolls_easy_install.png";